<div class="card">
   <div class="card-header">
     <h5>{{ 'Finance' | translate }}</h5>
   </div>
   <div class="card-body">
     <div class="chart-container column-container">
       <div id="columnchart">
         <apx-chart [chart]="finance.chart" [dataLabels]="finance.dataLabels" [stroke]="finance.stroke" [series]="finance.series" [title]="finance.title" [subtitle]="finance.subtitle" [fill]="finance.fill" [xaxis]="finance.xaxis" [yaxis]="finance.yaxis" [legend]="finance.legend" [responsive]="finance.responsive"></apx-chart>
       </div>
     </div>
   </div>
 </div>